import router, { isRoutesAdded, setRoutesAdded, markRoutesNeedReset, isBenignNavError } from '@/router'
import store from '@/store'
import { getToken } from '@/utils/auth'
import { filterMenusByActions, flattenMenuRoutes, hasActionPermission } from '@/router/menus'
import { message } from 'ant-design-vue'

function addDynamicRoutes (actions) {
  const menus = flattenMenuRoutes(filterMenusByActions(actions))
  menus.forEach(route => {
    router.addRoute('Root', {
      path: route.path.replace(/^\//, ''),
      name: route.name,
      meta: route.meta,
      component: route.component
    })
  })
  // 避免重复挂载 catch-all
  if (!router.getRoutes().some(r => r.path === '*' || r.name === 'NotFound')) {
    router.addRoute({
      path: '*',
      name: 'NotFound',
      component: () => import('@/views/exception/404.vue'),
      meta: { public: true }
    })
  }
  setRoutesAdded(true)
}

/** 登录后 / 鉴权后确保动态路由已注册，返回是否新注入 */
export function ensureRoutes (actions, force) {
  if (force) {
    markRoutesNeedReset()
  }
  if (!isRoutesAdded()) {
    addDynamicRoutes(actions || [])
    return true
  }
  return false
}

/** 带忽略重定向/取消噪音的跳转（router 已全局 patch，此处保留兼容调用） */
export function safeReplace (location) {
  return router.replace(location).catch(err => {
    if (isBenignNavError(err)) return err
    return Promise.reject(err)
  })
}

export function safePush (location) {
  return router.push(location).catch(err => {
    if (isBenignNavError(err)) return err
    return Promise.reject(err)
  })
}

router.beforeEach(async (to, from, next) => {
  if (to.meta && to.meta.public) {
    // 已登录访问登录页 → 进首页
    if (to.path === '/login' && getToken()) {
      next({ path: '/dashboard', replace: true })
      return
    }
    next()
    return
  }
  const token = getToken()
  if (!token) {
    next({ path: '/login', query: { redirect: to.fullPath } })
    return
  }
  try {
    if (!store.state.actions.length) {
      const { actions } = await store.dispatch('GetAuth')
      const added = ensureRoutes(actions, false)
      if (added) {
        next({ path: to.fullPath, replace: true })
      } else {
        next()
      }
      return
    }
    if (!isRoutesAdded()) {
      ensureRoutes(store.state.actions, false)
      next({ path: to.fullPath, replace: true })
      return
    }
    const need = to.meta && to.meta.action
    if (need && !hasActionPermission(store.state.actions, need)) {
      message.error('无访问权限')
      next({ path: '/dashboard' })
      return
    }
    next()
  } catch (e) {
    await store.dispatch('Logout')
    markRoutesNeedReset()
    next({ path: '/login' })
  }
})
